import { useMutation } from "react-query";
import { updateOfficeAppliance } from "../api/officeApplianceService";

const useUpdateOfficeAppliance = () => {
  return useMutation(updateOfficeAppliance);
};
export default useUpdateOfficeAppliance;
